module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "open": _vm.open
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "col-xs-8 col-xs-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    staticClass: "video",
    attrs: {
      "src": "https://www.youtube.com/embed/B0fIlEU8kQY",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96054482"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/modals/VideoModal.vue
// module id = 670
// module chunks = 5